import React from 'react';
import {
	func,
	array,
	string,
	oneOfType,
	object,
	bool
} from 'prop-types';
import style from './style';
import '../../../i18n';
import {InfoTooltip} from '../../molecules/Tooltip';
import { withNamespaces } from 'react-i18next';
import RecipeListitem from '../../molecules/RecipeListItem/index';

const Presenter = ({ recipes, enableCreating, onAddRecipe, onClickRecipe, currentRecipeId,t,showHelp,toggleShowHelp }) => {
	const selectedRecipeIndex = recipes.findIndex(recipe => currentRecipeId === recipe.id);
	return (
		<style.RecipeListWrapper>
			<style.ShowRecipesHeader>
				<div id='label'>
					<div>
						<style.RecipeIcon/>
						<style.Label>RECIPES</style.Label>
					</div>
					<div>
						<InfoTooltip text={t('create-quiz.WhatIsRecipe')}>
							<style.IconButton onClick={toggleShowHelp(!showHelp)}>
								<style.QuestionIcon/>
							</style.IconButton>
						</InfoTooltip>
					</div>
				</div>
				{showHelp&&(
					<style.HelpBox 
						onClose={toggleShowHelp(false)}
						term={(<React.Fragment><style.InfoIcon/>{t('create-quiz.RecipeSummary')}</React.Fragment>)}
						description={<span>{t('create-quiz.RecipeDetail')}</span>}
					/>
				)}
				
				<style.NewItemForm
					placeholder={enableCreating? t('create-quiz.InputNewRecipe') : t('create-quiz.CannotAddAnyMore')}
					onAddItem={onAddRecipe}
					disabled={!enableCreating}
				/>
			</style.ShowRecipesHeader>
			<style.ColumnFlexItemWrapper>
				{
					recipes && recipes.map((recipe, index) =>
						<RecipeListitem
							key={recipe.name + index}
							recipe={recipe}
							checked={index === selectedRecipeIndex}
							onClick={() => { onClickRecipe(recipe); }}
						/>)
				}
			</style.ColumnFlexItemWrapper>
		</style.RecipeListWrapper>
	);
};


Presenter.propTypes = {
	onAddRecipe: func.isRequired,
	onClickRecipe: func.isRequired,
	enableCreating : bool.isRequired,
	recipes: array.isRequired,
	currentRecipeId: string,
	error: oneOfType([
		string,
		object,
	]),
	showHelp : bool.isRequired,
	t : func.isRequired,
	toggleShowHelp : func.isRequired
};

export default withNamespaces()(Presenter);